import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  ApproveOrRejectPendingOrderParams,
  GetOrderReportParams,
} from 'lib/api/requests/order/order.requests.types';
import iotApi from '../../api/iotApi.client';
import { OrderQueryKey } from './order.hooks.keys';

export function useGetOrdersReport() {
  return useMutation({
    mutationFn: async (data: GetOrderReportParams) => {
      const res = await iotApi.order.getOrdersReport(data);

      return res;
    },
  });
}

export function useApproveOrRejectPendingOrder() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: ApproveOrRejectPendingOrderParams) => {
      const res = await iotApi.order.approveOrRejectPendingOrder(data);

      return res;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [OrderQueryKey.GetOrdersByTypeAndStatus],
      });
    },
  });
}
